import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "0d089b91-63af-48e4-b5fb-2c9376ff2059",
    content: "Longer low-frequency reverberation, compared to the one at middle frequencies.",
    options: {},
  },
  {
    id: "8fed1e2b-1eb7-49c1-986f-8abe178c8db9",
    content: "Longer high-frequency reverberation, compared to the one at middle frequencies.",
    options: {},
  },
  {
    id: "f65b4b6c-8c96-436a-871d-e9347318420b",
    content: "Long reverberation in the entire frequency range of interest.",
    options: {},
  },
  {
    id: "53742312-3b80-4039-91c9-ac18e571375b",
    content: "Shorter low-frequency reverberation, compared to the one at middle frequencies.",
    options: {},
  },
];

export const task: Task = {
  id: "45e1f5c7-ae32-4af2-828e-dd057c41c7d2",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["0d089b91-63af-48e4-b5fb-2c9376ff2059"],
};
